import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken } from '~/store/cookies'
// axios 配置
axios.defaults.timeout = 50000
axios.defaults.baseURL = ''
axios.defaults.responseType = 'json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.delete['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.delete['Accept'] = 'application/json'
axios.defaults.headers.delete['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'
axios.defaults.headers.put['Accept'] = 'application/json '
axios.defaults.headers.get['Content-Type'] = 'application/json'
axios.defaults.headers.get['Accept'] = 'application/json '
let lang = 'en'
axios.interceptors.request.use(
  function (config: any) {
    if (config && config.headers && config.headers.lang) {
      lang = config.headers.lang
    }
    config.headers.Authorization = getToken()

    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  function (response) {
    // debugger
    if (response.data.code === 10000) {
      // 系统级错误
      let mes =
        lang === 'en'
          ? 'System error. Please contact your administrator.'
          : '系统异常，请联系管理员。'
      ElMessage.error(mes)
      return Promise.reject(new Error('接口报错了，请在控制台查看接口错误'))
    } else if (response.data.code === 10019) {
      let mes =
        lang === 'en'
          ? 'System error. Please contact your administrator.'
          : '系统异常，请联系管理员。'
      ElMessage.error(mes)
      return Promise.reject(new Error('接口报错了，请在控制台查看接口错误'))
    }
    if (response.data.code === 10001 || response.data.code === 401) {
      setToken('')
      window.location.href = '/login'
      // window.location.reload()
      // reGetToken()
      console.log('ElMessage:')
    }
    return response
  },
  function (error) {
    console.log('error:', error)
    return Promise.reject(new Error('接口报错了，请在控制台查看接口错误'))
  }
)
